import { Component } from '@angular/core';
import {AuthService} from './core/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'zastitatrade';


  constructor(public authService: AuthService) {
  }

}
